/* istanbul ignore file */
import { Spinner } from '@pcln/horizon'

function LoadIndicator() {
  return (
    <div className='flex justify-around' data-testid='spinner'>
      <Spinner />
    </div>
  )
}
export default LoadIndicator
